<template>
   <footer class="footer">
       <div class="footsbox">
           <table>
               <tbody>
                   <tr>
                       <td class="nfootlogo" rowspan="3">
                            <img src="@/assets/img/footlogo2025.png" height="87">
                        </td>
                       <td>
                           <h3>Secretariat Office</h3>
                           <p><b>Humming IMC Co., Ltd.</b></p>
                           <p>9F, 311, Gangnam-daero, Seocho-gu, Seoul, South Korea | Business Registry Number:
                               107-87-11721<br>
                               E-mail: koreaderma@akd.or.kr Tel: +82-2-2038-7976 Fax: +82-2-520-1588</p>
                       </td>
                   </tr>
                   <tr>
                       <td>
                           <h3>Organization Office</h3>
                           <p><b>The Association of Korean Dermatologists</b></p>
                           <p>5F, 44, Seocho-daero 78-gil, Seocho-gu, Seoul, Republic of Korea | Business Registry
                               Number: 214-82-63594<br>
                               E-mail: admin@akd.or.kr Tel: +82-2-521-3141 Fax: +82-2-521-3142</p>
                       </td>
                   </tr>
                   <tr>
                       <td>
                           <div class="footinfobox">
                               <p class="pri">
                                <a href="/privacy">Privacy Policies</a> 
                            </p>
                               <p class="footnsns">
                                   <a href="https://www.facebook.com/Koreaderma-2023-115793911396638" target="_blank">
                                       <img src="@/assets/img/footsns01-1.png">
                                   </a>
                                   <a href="https://www.instagram.com/koreaderma_official/" target="_blank">
                                       <img src="@/assets/img/footsns01-2.png">
                                   </a>
                                   <a href="https://www.youtube.com/@%EB%8C%80%ED%95%9C%ED%94%BC%EB%B6%80%EA%B3%BC%EC%9D%98%EC%82%AC%ED%9A%8C" target="_blank">
                                       <img src="@/assets/img/footsns01-3.png">
                                   </a>
                               </p>
                           </div>
                           <div class="ncopy">Copyright ⓒ KOREADERMA 2025 All Rights Reserved.</div>
                       </td>
                   </tr>
               </tbody>
           </table>
       </div>
   </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>


<style>
.footer {
    background: #d5e4b5;
    padding: 30px;
}
.footsbox{
    max-width: 1170px;
    margin: 0 auto;
}
.footsbox table {
    border-collapse: collapse;
    border-spacing: 0;
    max-width: 100%;
    width: 100%;
}
.footsbox table tr td {
    padding-bottom: 40px;
}
.footsbox table tr td.nfootlogo {
    vertical-align: top;
}
.footsbox table tr td h3 {
    padding: 3px 8px;
    background: #becba2;
    display: inline-block;
    font-size: 16px;
    color: #464646;
    font-weight: 500;
    margin-bottom: 8px;
}
.footsbox table tr td p {
    margin-top: 0;
    font-size: 14px;
    font-weight: 300;
    color: #464646;
}
.footinfobox {
    margin-bottom: 15px;
}
.footinfobox .pri {
    display: inline-block;
    font-size: 10px;
}
.pri a {
    margin-right: 10px;
    text-decoration: underline;
    color: #464646;
}
.footinfobox .footnsns {
    float: right;
    display: inline-block;
}
.footinfobox .footnsns a {
    margin-left: 15px;
}
.ncopy {
    font-size: 10px;
}
</style>
